import './Flashcards.css';
import Flashcardform from './Flashcardform/Flashcardform';
import Flashcardselection from './Flashcardselection';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import {
  getFlashcards,
  getAllFlashcardHeaders,
  getFlashcardBody,
} from '../../actions/flashcards';
import { getTrainings } from '../../actions/trainings';
import React, { useState, useEffect } from 'react';
import IconButton from '@material-ui/core/IconButton';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import { Button } from '@material-ui/core';
import CircularProgress from '@mui/material/CircularProgress';

const useStyles = makeStyles((theme) => ({
  root: {
    '& .MuiTextField-root': {
      margin: theme.spacing(1),
    },
  },
  paper: {
    padding: theme.spacing(2),
  },
  form: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
  },
  fileInput: {
    width: '97%',
    margin: '10px 0',
  },
  buttonSubmit: {
    margin: 10,
  },
  buttonClear: {
    margin: 10,
  },
}));

const Flashcardedit = () => {
  const flashcardHeaders = useSelector((state) => state.flashcardHeaders);
  const [open, setOpen] = useState(false);
  const flashcards = useSelector((state) => state.flashcards);
  const [currentId, setCurrentId] = useState(0);
  const [progress, setProgress] = useState(0);
  const classes = useStyles();

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getAllFlashcardHeaders());
    dispatch(getTrainings());
  }, [currentId, dispatch]);

  const handleClickCreate = () => {
    setCurrentId(0);
    setOpen(true);
  };

  const handleClickClose = () => {
    setOpen(false);
  };

  const handleClickEdit = (currentId) => {
    setCurrentId(currentId);
    setOpen(true);
  };

  let form;
  if (open) {
    form = (
      <Flashcardform
        flashcardHeaders={flashcardHeaders}
        currentId={currentId}
        close={handleClickClose}
      />
    );
  }

  return (
    <div>
      {form}
      <h2>Edit flashcard:</h2>
      <Flashcardselection
        flashcardHeaders={flashcardHeaders}
        setCurrentId={handleClickEdit}
      />
      <br />
      <IconButton onClick={handleClickCreate} aria-label="delete">
        <AddCircleIcon />
      </IconButton>
      create flascard
      <br />
      Download flashcards and store into local storage:
      <CircularProgress variant="determinate" value={progress} />
      <Button
        className={classes.buttonSubmit}
        variant="contained"
        color="primary"
        size="large"
        type="submit"
        fullWidth
        onClick={(e) => {
          for (let i = 0; i < flashcardHeaders.length; i++) {
            setProgress(100 * ((i + 1) / flashcardHeaders.length));
            dispatch(getFlashcardBody(flashcardHeaders[i]._id));
          }
        }}
      >
        Process
      </Button>
    </div>
  );
};

export default Flashcardedit;
